import { logException, logMessage } from "@punchup/sentry";

import { getApiClient } from "./apiRegistry";
import { notFound } from "next/navigation";

/**
 * Revalidates the vercel cache for the given path, from the client.
 */
export async function revalidatePathClient(path: string) {
  const searchParams = new URLSearchParams({ path });
  await getApiClient().get("/api/revalidate?" + searchParams);
}

// We don't want to log warnings for paths that are known to be noisy, which we have identified below.
export const knownNoisyPathsRegex =
  /\.php|\.wp|icon-512x512\.png|apple-touch-icon-120x120-precomposed\.png|apple-touch-icon-precomposed\.png|\.well-known|favicon\.ico|apple-touch-icon\.png/i;

/**
 * Returns the 404 Not Found page
 *
 * Also logs a Sentry warning, logging what was not found.
 *
 * ! FOR SERVER USE ONLY !
 *
 * Do not use this function in client code. This calls `notFound()`, which renders a 404 page,
 * which is not applicable in client code where a response has already been returned.
 */
export function returnNotFoundAndLogWarning(whatIsNotFound: string): never {
  if (typeof window !== "undefined") {
    logException("returnNotFoundAndLogWarning used in client code");
    if (process.env.NODE_ENV === "development") {
      throw new Error(
        "returnNotFoundAndLogWarning used in client code. Please fix this."
      );
    }
  }

  if (!knownNoisyPathsRegex.test(whatIsNotFound)) {
    logMessage("Not found: " + whatIsNotFound, {
      level: "warning",
    });
  }

  notFound();
}
